export default "__VITE_PUBLIC_ASSET__f33a9e52__"